export default "__VITE_ASSET__D$FA_vJ9__"